import React from "react";
import { EContainerVariant, EIconNames, ETextVariant } from "../../types";
import { Text, Icon, Box, Container } from "../../components";

interface Props {
  title?: string;
  icon?: EIconNames;
  children?: React.ReactNode;
}

const ErrorSection: React.FC<Props> = ({
  title = "",
  icon = EIconNames.AlertInfo,
  children,
}) => {
  return (
    <Container variant={EContainerVariant.Small}>
      <Box jc="center" style={{ marginBottom: "20px" }}>
        <Icon name={icon} width={40} height={40} />
      </Box>
      <Text variant={ETextVariant.Title4} center>
        {title}
      </Text>
      <Text center>{children}</Text>
    </Container>
  );
};

export default ErrorSection;
